module.exports = __webpack_public_path__ + "static/img/white_staking_discount_coupon.99be3974.png";